import React, { useState, useEffect } from "react";
import BaseEmailComponent from "../BaseEmailComponent";
import EmailImageUpload from "../EmailImageUpload";
import { Form, Button } from "react-bootstrap";

const ProductGrid = ({ id, data, onUpdate, styleSettings }) => {
  const [products, setProducts] = useState(
    data?.products || Array.from({ length: 4 }, () => ({
      name: "Product Name",
      price: "₹0",
      image: null
    }))
  );

  // Update products when data changes
  useEffect(() => {
    if (data && data.products) {
      setProducts(data.products);
    }
  }, [data]);

  // Handle product updates
  const handleProductUpdate = (index, field, value) => {
    const updatedProducts = [...products];
    updatedProducts[index] = {
      ...updatedProducts[index],
      [field]: value
    };
    setProducts(updatedProducts);
  };

  // Edit UI with product grid editor
  const renderEditUI = ({ title, setTitle, description, setDescription, handleSaveChanges, styleSettings }) => {
    // Function to save all changes at once
    const saveAllChanges = () => {
      handleSaveChanges(title, description, { products });
    };

    return (
      <div className="p-3 rounded" style={{ backgroundColor: 'white' }}>
        <Form.Group className="mb-3">
          <Form.Label><strong>Grid Title</strong></Form.Label>
          <Form.Control
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={saveAllChanges}
            placeholder="Enter Grid Title"
          />
        </Form.Group>
        
        <div className="mb-3">
          <strong>Products</strong>
        </div>

        <div className="row">
          {products.map((product, index) => (
            <div className="col-md-6 col-lg-3 mb-4" key={index}>
              <div className="border rounded p-3">
                <EmailImageUpload
                  initialImage={product.image}
                  onImageUpload={(imageData) => {
                    handleProductUpdate(index, "image", imageData);
                    saveAllChanges();
                  }}
                  allowRegenerate={true}
                  label={`Product ${index + 1} Image`}
                />
                
                <Form.Group className="mb-2 mt-3">
                  <Form.Label><small>Product Name</small></Form.Label>
                  <Form.Control
                    type="text"
                    value={product.name}
                    onChange={(e) => handleProductUpdate(index, "name", e.target.value)}
                    onBlur={saveAllChanges}
                    size="sm"
                  />
                </Form.Group>
                
                <Form.Group className="mb-2">
                  <Form.Label><small>Price</small></Form.Label>
                  <Form.Control
                    type="text"
                    value={product.price}
                    onChange={(e) => handleProductUpdate(index, "price", e.target.value)}
                    onBlur={saveAllChanges}
                    size="sm"
                  />
                </Form.Group>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // View UI for display mode
  const renderViewUI = ({ title, description, styleSettings }) => {
    const { primaryColor, secondaryColor, fontFamily } = styleSettings || {};

    return (
      <div>
        {title && (
          <h3 style={{ 
            fontSize: "24px", 
            marginBottom: "20px",
            color: secondaryColor || "#a1894c",
            fontFamily,
            textAlign: "center"
          }}>
            {title}
          </h3>
        )}
        
        <div className="row">
          {products.map((product, index) => (
            <div className="col-md-6 col-lg-3 mb-4" key={index}>
              <div className="product-card h-100 border rounded overflow-hidden" style={{ boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                <div style={{ height: "180px", overflow: "hidden" }}>
                  {product.image ? (
                    <img 
                      src={product.image} 
                      alt={product.name} 
                      className="w-100 h-100" 
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <div className="d-flex align-items-center justify-content-center h-100 bg-light">
                      <img
                        src="/img-preview.svg"
                        alt="Product placeholder"
                        style={{ maxHeight: "80px" }}
                      />
                    </div>
                  )}
                </div>
                
                <div className="p-3">
                  <h5 style={{ 
                    fontSize: "16px", 
                    color: primaryColor || "#333333",
                    fontFamily,
                    marginBottom: "8px"
                  }}>
                    {product.name}
                  </h5>
                  
                  <div style={{ 
                    fontWeight: "bold",
                    color: secondaryColor || "#a1894c",
                    fontFamily
                  }}>
                    {product.price}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <BaseEmailComponent
      id={id}
      data={data}
      onUpdate={onUpdate}
      componentName="Product Grid"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
    />
  );
};

export default ProductGrid; 